import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cerrarMenu, seleccionarPagina } from "../../../features/ui/uiSlice";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import { useForm } from "../../../hooks/useForm";
import { Spinner } from "../../../components/Spinner";
import {
  useGenerarCasMutation,
  useGuardarDatosAdicionalesMutation,
  useLazyVerPolizaQuery,
  useVerInformacionPolizaQuery,
} from "../../../services/docs";
import { RootState } from "../../../store";
import Button from "../../../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { InputField } from "../../../components/ui/InputField";
import { SaveAll, User } from "lucide-react";
import { Boton } from "../../../components/ui/Boton";

export const InformacionScreen = () => {
  const dispatch = useDispatch();
  const [fi_queja, setFi_queja] = useState(false);
  const [guardarDatosAction, { isLoading: LGuardaDatosAdicional }] =
    useGuardarDatosAdicionalesMutation();
  const [generarCasAction, { isLoading: LgenerarCas }] =
    useGenerarCasMutation();

  const [verAction] = useLazyVerPolizaQuery();

  const { seleccion, p_seleccion } = useSelector(
    (state: RootState) => state.ui
  );
  const generarCas = async () => {
    const resp = await generarCasAction({
      ...levantarCas,
      fi_tipo_queja: +levantarCas.fi_tipo_queja,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        } else {
          toastr.error(err.data.message);
        }
      });
    if (resp) {
      verAction(seleccion);
      toastr.info(resp.message);
    }
  };

  const guardarDatosAdicionales = async () => {
    if (
      datosAdicionales.fc_techos.trim() === "" ||
      datosAdicionales.fc_muros.trim() === "" ||
      datosAdicionales.fc_genero.trim() === ""
    ) {
      toastr.error("Debe Llenar todos los campos");
      return;
    }
    const resp = await guardarDatosAction({
      ...datosAdicionales,
      fi_niveles: +datosAdicionales.fi_niveles,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        } else {
          toastr.error(err.data.message);
        }
      });
    if (resp) {
      verAction(seleccion);
      toastr.info(resp.message);
    }
  };

  const { data, isLoading } = useVerInformacionPolizaQuery(seleccion);
  const {
    formulario: levantarCas,
    handleInputChange,
    handleSelectChange,
    handleChangeAll,
    handleTexareChange,
  } = useForm({
    fc_nombre: "",
    fc_apellido_paterno: "",
    fc_apellido_materno: "",
    fi_tipo_informacion: "",
    fc_comentarios: "",
    fc_queja: "NO",
    fi_tipo_queja: "",
    fc_id: seleccion,
  });
  useEffect(() => {
    if (data) {
      if (data.informacion) {
        dispatch(cerrarMenu());
        handleChangeAll({
          fc_nombre: data.informacion.Contratante,
          fc_apellido_paterno: data.informacion.ApellidoP_Contratante,
          fc_apellido_materno: data.informacion.ApellidoM_Contratante,
        });
      }
    }
  }, [data]);
  const {
    formulario: datosAdicionales,
    handleInputChange: handleInputChangeAd,
    handleSelectChange: handleSelectChangeAd,
    handleChangeAll: hcallAd,
  } = useForm({
    fc_genero: "",
    fc_muros: "",
    fi_niveles: 0,
    fc_techos: "",
    fc_sontano: "SI",
    fc_id: seleccion,
  });
  useEffect(() => {
    dispatch(seleccionarPagina("p-informacion"));
  }, [0]);

  useEffect(() => {
    handleChangeAll({
      fc_id: seleccion,
    });
    hcallAd({ fc_id: seleccion });
  }, [seleccion]);
  useEffect(() => {
    if (levantarCas.fc_queja === "SI") {
      setFi_queja(true);
    } else {
      setFi_queja(false);
    }
  }, [levantarCas.fc_queja]);

  if (isLoading) {
    return (
      <div className="flex w-full justify-center">
        <Spinner />
      </div>
    );
  }
  return (
    <div className="w-full bg-[#faf9f9]">
      <h1 className="mb-5 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary ">
        Información
      </h1>

      <div className="card gab-6 mt-5 grid grid-cols-1 place-items-center space-x-4 rounded-2xl rounded-xl border border-slate-100 bg-[#faf9f9] p-6 shadow-sm md:grid-cols-1 xl:grid-cols-2">
        <div className="w-full rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
          <div className="flex items-center gap-3 border-l-4 border-metric-blue-700 pl-4">
            <h2 className="text-md font-manrope font-bold text-slate-900">
              Levantar Cas de Información
            </h2>
          </div>
          <div className="my-5">
            <InputField
              value={levantarCas.fc_nombre || ""}
              onChange={handleInputChange}
              name="fc_nombre"
              label="Nombre:"
              placeholder=""
              icon={User}
            />
          </div>
          <div className="my-5">
            <InputField
              value={levantarCas.fc_apellido_paterno || ""}
              onChange={handleInputChange}
              name="fc_apellido_paterno"
              label="Apellido Paterno:"
              placeholder=""
              icon={User}
            />
          </div>
          <div className="my-5">
            <InputField
              value={levantarCas.fc_apellido_materno || ""}
              onChange={handleInputChange}
              name="fc_apellido_materno"
              label="Apellido Materno:"
              placeholder=""
              icon={User}
            />
          </div>
          <div className="my-5">
            <Label
              htmlFor="fi_tipo_informacion"
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
            >
              Tipo Información:
            </Label>
            <select
              name="fi_tipo_informacion"
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              onChange={handleSelectChange}
            >
              <option value="">Selecciona una opción</option>
              {data &&
                data.tipo_informacion &&
                data.tipo_informacion.map((b: any) => {
                  return (
                    <option key={b.Idinformacion} value={b.Idinformacion}>
                      {b.Descripcion}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="my-5">
            <Label
              htmlFor="fi_tipo_informacion"
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
            >
              Comentarios:
            </Label>
            <textarea
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              onChange={handleTexareChange}
              value={levantarCas.fc_comentarios || ""}
              name="fc_comentarios"
              id=""
              cols={40}
              rows={2}
            ></textarea>
          </div>
          <div className="my-5">
            <Label
              htmlFor="fi_tipo_informacion"
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
            >
              Esto es una queja?:
            </Label>
            <select
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              name="fc_queja"
              onChange={handleSelectChange}
              defaultValue={levantarCas.fc_queja}
            >
              <option key={0} value="">
                Selecciona una opción
              </option>
              <option key={"1"} value={"NO"}>
                NO
              </option>
              <option key={"2"} value={"SI"}>
                SI
              </option>
            </select>
          </div>
          {fi_queja && (
            <div className="my-5">
              <Label
                htmlFor="fi_tipo_queja"
                className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
              >
                Tipo de queja:
              </Label>
              <select
                className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                name="fi_tipo_queja"
                onChange={handleSelectChange}
              >
                <option key={0} value="">
                  Selecciona una opción
                </option>
                {data &&
                  data.quejas &&
                  data.quejas.map((b: any) => {
                    return (
                      <option key={b.QuejaID} value={b.QuejaID}>
                        {b.Descripcio}
                      </option>
                    );
                  })}
              </select>
            </div>
          )}
          <div className="my-5">
            {!LgenerarCas && (
              <Boton icon={SaveAll} onClick={generarCas}>
                Generar CAS
              </Boton>
            )}
            {LgenerarCas && (
              <div className="flex w-full justify-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
        <div className="w-full rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
          <div className="flex items-center gap-3 border-l-4 border-metric-blue-700 pl-4">
            <h2 className="text-md font-manrope font-bold text-slate-900">
              Datos Adicionales
            </h2>
          </div>
          <div className="my-5">
            <Label
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
              htmlFor="fc_genero"
            >
              Genero:
            </Label>
            <select
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              name="fc_genero"
              onChange={handleSelectChangeAd}
              defaultValue={datosAdicionales.fc_genero}
            >
              <option key={0} value="">
                Selecciona una opción
              </option>
              <option key={"1"} value={"1"}>
                Masculino
              </option>
              <option key={"2"} value={"2"}>
                Femenino
              </option>
            </select>
          </div>
          <div className="my-5">
            <Label
              htmlFor="fc_muros"
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
            >
              Muros:
            </Label>
            <select
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              name="fc_muros"
              onChange={handleSelectChangeAd}
            >
              <option key={0} value="">
                Selecciona una opción
              </option>
              {data &&
                data.muros &&
                data.muros.map((b: any) => {
                  return (
                    <option key={b.MurosID} value={b.MurosID}>
                      {b.Descripcion}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="my-5">
            <Label
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
              htmlFor="fi_niveles"
            >
              Niveles:
            </Label>
            <Input
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              type="number"
              name="fi_niveles"
              value={+datosAdicionales.fi_niveles}
              onChange={handleInputChangeAd}
            />
          </div>
          <div className="my-5">
            <Label
              htmlFor="fi_tipo_queja"
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
            >
              Techos:
            </Label>
            <select
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              name="fc_techos"
              onChange={handleSelectChangeAd}
            >
              <option key={0} value="">
                Selecciona una opción
              </option>
              {data &&
                data.techos &&
                data.techos.map((b: any) => {
                  return (
                    <option key={b.TechoID} value={b.TechoID}>
                      {b.Descripcion}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="my-5">
            <Label
              className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
              htmlFor="fi_niveles"
            >
              Sotano:
            </Label>
            <select
              className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
              name="fc_sontano"
              onChange={handleSelectChangeAd}
              defaultValue={datosAdicionales.fc_sontano}
            >
              <option key={"1"} value={"NO"}>
                No
              </option>
              <option key={"2"} value={"SI"}>
                Si
              </option>
            </select>
          </div>
          <div className="my-5">
            {!LGuardaDatosAdicional && (
              <Boton icon={SaveAll} onClick={guardarDatosAdicionales}>
                Guardar Datos
              </Boton>
            )}
            {LGuardaDatosAdicional && (
              <div className="flex w-full justify-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
